import { FaEdit } from 'react-icons/fa';
import { useEditMode } from '../../context/EditModeContext';
import { useEditorCapability } from '../../hooks/useEditorCapability';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useT } from '../../hooks/useT';
import styles from './EditModeToggle.module.css';

function EditModeToggle() {
  const { editMode, setEditMode } = useEditMode();
  const { supported } = useEditorCapability();
  const isMobile = useIsMobile();
  const t = useT();
  const isActive = editMode === 'visitor';

  // Desktop uses a fixed side column and never depends on a dynamic viewport
  // unit, so the capability gate only applies below the breakpoint.
  const blocked = isMobile && !supported;

  const handleToggle = () => {
    if (blocked) return;
    setEditMode(isActive ? 'off' : 'visitor');
  };

  return (
    <>
      <button
        className={`${styles.toggle} ${isActive ? styles.active : ''}`}
        onClick={handleToggle}
        disabled={blocked}
        aria-label="Toggle edit mode"
        aria-describedby={blocked ? 'edit-unsupported' : undefined}
      >
        <FaEdit className={styles.icon} />
        <span className={styles.label}>{t('aitools.editToggle', 'Edit My Page')}</span>
        <div className={`${styles.switch} ${isActive ? styles.switchOn : ''}`}>
          <div className={styles.switchThumb} />
        </div>
      </button>
      {blocked && (
        <p id="edit-unsupported" className={styles.unsupported}>
          {t(
            'editor.unsupportedBrowser',
            'Editing needs a newer mobile browser. Open this page on a computer, or update your browser to try it.'
          )}
        </p>
      )}
    </>
  );
}

export default EditModeToggle;
